import styled from 'styled-components';

export const OptionListStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const OptionStyles = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  cursor: pointer;
  background: ${({ isSelected }) => (isSelected ? '#803EFF' : '#FFFFFF1A')};
  transition: all 0.2s ease;

  padding: 16px 32px 16px 20px;

  .option-content {
    flex: 1;
  }

  .option-title {
    margin: 0 0 4px 0;
  }

  .option-subtitle {
    margin: 0;
  }
`;

export const OptionIconStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;

  .emoji {
    font-size: 40px;
  }
`;
